<template>
  <validation-provider v-slot="{ valid, errors }" :name="$attrs.name" :rules="rules">
    <b-form-group :label="$attrs.label" v-bind="dynamicAttrs" :description="$attrs.description">
      <b-form-input
        v-if="mask"
        :type="type"
        v-model="inputValue"
        :state="errors[0] ? false : valid ? true : null"
        v-mask="mask"
        :disabled="disabled"
      />
      <b-form-input
        v-else
        :type="type"
        v-model="inputValue"
        :state="errors[0] ? false : valid ? true : null"
        :disabled="disabled"
      />
      <b-form-invalid-feedback v-if="errors[0]">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </validation-provider>
</template>

<script>
export default {
  props: {
    rules: {
      type: [Object, String],
      default: ''
    },
    value: null,
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dynamicAttrs: {
      type: Object,
      default: () => {}
    },
    mask: {
      type: [String, Object],
      default: ''
    }
  },
  data: () => ({
    inputValue: ''
  }),
  watch: {
    inputValue(newValue) {
      this.$emit('input', newValue)
    },
    value(newValue) {
      this.inputValue = newValue
    }
  },
  created() {
    if (this.value) {
      this.inputValue = this.value
    }
  }
}
</script>
